import React from 'react';
import { connect } from 'react-redux';
import ProductAddonForm from './ProductAddonForm';
import privateView from '../../components/hocs/privateView';
import Analytics from "../../services/Analytics";

class ProductAddonDetail extends React.Component{
	componentDidMount(){
    const { email } = this.props.injectedProps;
    Analytics.recordPageView('product_addon_detail', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }
  render(){
    return(
      <div className="animate fadeIn">
        <ProductAddonForm
          title="Product Addon Details"
          edit
          useCrop
          {...this.props}
        />
      </div>
    )
  }
}

const mapStateToProps = ({auth: { isFetch, roles, isLogged, id, email } })=>({
  guardData: { isFetch, roles, isLogged, id, email }
})

const enhance = connect(mapStateToProps);

export default enhance(privateView(ProductAddonDetail, ['supervisor', 'sale_supervisor']));